import { AstraParagraph, AstraTooltip } from '~/astra'
import { ButtonTag } from '~/components'
import { PractitionerChipWithTooltip } from '~/components/PractitionerChip'
import { Location, PractitionerStatusDefinition, RecurringAssignmentType } from '~/storm'

type Props = {
    uniqueStatuses: PractitionerStatusDefinition[]
    uniqueRooms?: Location[]
    assignment: RecurringAssignmentType
}

export const RecurringAssignmentHeader = ({ uniqueStatuses, uniqueRooms, assignment }: Props) => {
    if (!assignment.practitioner) {
        return null
    }
    return (
        <div className="flex items-center gap-2.5 pr-4">
            <PractitionerChipWithTooltip shortName={assignment.practitioner.short_name} />
            {uniqueStatuses.map(status => (
                <div className="flex h-8 w-12 items-center" key={status.code}>
                    <ButtonTag colorType={status.color} label={status.label} fillType="all" disableHover />
                </div>
            ))}
            {uniqueRooms?.map(room => (
                <div className="flex h-8 w-12 items-center" key={room.room_code}>
                    <ButtonTag colorType="room" label={room.room_code} fillType="all" disableHover />
                </div>
            ))}
            <AstraTooltip tooltipContent={assignment.title}>
                <AstraParagraph className="grow truncate">{assignment.title}</AstraParagraph>
            </AstraTooltip>
        </div>
    )
}
